var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.mt ? ("mt-" + _vm.mt) : ''},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_c('v-row',_vm._l((_vm.data),function(ref){
var label = ref.label;
var value = ref.value;
var cols = ref.cols;
return _c('v-col',{key:label,staticClass:"pt-0",attrs:{"cols":cols ? cols : '6'}},[_c('v-text-field',{attrs:{"label":label,"value":value,"readonly":"","hide-details":""}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }